const axios = require('axios')

export default class Auth {
    login(data) {
        return axios.post('/login', data)
    }

    requestRestorePassword(data) {
        return axios.post('/request_restore', data)
    }

    restore(data) {
        return axios.post('/restore_pass', data)
    }
    
    logout() {
        return axios.post('/logout')
    }
    
    register(data) {
        return axios.post('/register',  data)
    }

    confirm(data) {
        return axios.post('/confirm',  data)
    }

    getCurrentUser() {
        return axios.get('/users/current')
    }

    signature(id, data){
        return axios.post(`/users/${id}/signature`,  data)
    }

    verifyToken(data) {
        return axios.post('/verify_token',  data)
    }
}